import React from 'react'

const FreeMargin = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className='size-7' viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ><circle cx="12" cy="12" r="10" /><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" /><path d="M12 18V6" /></svg>
    )
}

export default FreeMargin